<!-- src/app/date-navigation/date-navigation.component.html -->
<div class="date-navigation-container">

  <!-- Optional: Display selected date -->
  <p *ngIf="dateControl.value" style="font-size:14px;width:100%">
    Report Date:<br><span
    style="font-size:24px;font-weight:600;color: #456c30;"> {{ dateControl.value | date:'fullDate' }}</span>
  </p>


  <div class="navigation-buttons">
    <button mat-raised-button color="primary" (click)="goToPreviousDay()" aria-label="Previous Day">
      <mat-icon>chevron_left</mat-icon>
    </button>

    <button mat-raised-button color="primary" (click)="goToNextDay()" aria-label="Next Day">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>

  <mat-form-field appearance="outline" class="date-picker-field">
    <mat-label>Selected Date</mat-label>
    <input
      matInput
      [matDatepicker]="picker"
      [formControl]="dateControl"
      placeholder="MM/DD/YYYY"
      readonly
    >
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>

</div>
